import ReportFinance from '../../../views/Finance/Report/ReportFinance.view';

export default ReportFinance;
